import { render, staticRenderFns } from "./vue-draggable-resizable.vue?vue&type=template&id=74b9cefe&scoped=true&"
import script from "./vue-draggable-resizable.vue?vue&type=script&lang=js&"
export * from "./vue-draggable-resizable.vue?vue&type=script&lang=js&"
import style0 from "./vue-draggable-resizable.vue?vue&type=style&index=0&id=74b9cefe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b9cefe",
  null
  
)

component.options.__file = "vue-draggable-resizable.vue"
export default component.exports